import gql from 'graphql-tag';
const CONCENTRATION_ACTIVITY_FRAGMENT = gql `
  fragment ConcentrationActivityFragment on ConcentrationActivity {
    rounds {
      id
      subtitle
      fact
      cardBack {
        id
        image {
          id
          src
          description
        }
      }
      leftColumn {
        id
        cardText
        answer
      }
      rightColumn {
        id
        cardText
        answer
      }
    }
  }
`;
export default CONCENTRATION_ACTIVITY_FRAGMENT;
